/**
 * BackStage n'a pas de locataire dans ses URL : aucun segment n'est un slug.
 *
 * Le kit s'en sert pour decider si le premier segment d'une route est un
 * prefixe de tenant a ignorer (`navigation.model.ts`). En renvoyant toujours
 * `undefined`, les routes BackStage sont lues telles quelles.
 */
export function parseTenantSlug(_raw: string | undefined | null): string | undefined {
  return undefined;
}
